<form (ngSubmit)="save()" [formGroup]="form">
    <div class="flex items-center" mat-dialog-title>
        <h2 *ngIf="form.get('code').value"
            class="headline m-0 flex-auto">{{ form.get('code').value }} - {{ form.get('description').value }}</h2>
        <h2 *ngIf="!form.get('code').value"
            class="headline m-0 flex-auto">Nuevo Nivel</h2>
    </div>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-content class="flex flex-col">
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Código</mat-label>
                <input cdkFocusInitial formControlName="code" matInput required>
                <mat-icon class="mr-3" matPrefix svgIcon="mat:code"></mat-icon>
                <mat-error *ngIf="form.get('code')?.hasError('required')">
                    El código es requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Descripción</mat-label>
                <input formControlName="description" matInput required>
                <mat-icon class="mr-3" matPrefix svgIcon="mat:subject"></mat-icon>
                <mat-error *ngIf="form.get('description')?.hasError('required')">
                    La descripción es requerida
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Nivel</mat-label>
                <input formControlName="level" matInput type="number" min="1" required>
                <mat-icon class="mr-3" matPrefix svgIcon="mat:layers"></mat-icon>
                <mat-error *ngIf="form.get('level')?.hasError('required')">
                    El nivel es requerido
                </mat-error>
                <mat-error *ngIf="form.get('level')?.hasError('min')">
                    El nivel debe ser mayor a 0
                </mat-error>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="flex-auto">
                <mat-label>Nivel Padre</mat-label>
                <mat-select formControlName="parent_id" [compareWith]="compareParentId">
                    <mat-option [value]="null">Sin nivel padre (Raíz)</mat-option>
                    <mat-option *ngFor="let parent of availableParents" [value]="parent.id">
                        {{ parent.code }} - {{ parent.description }}
                    </mat-option>
                </mat-select>
                <mat-icon class="mr-3" matPrefix svgIcon="mat:account_tree"></mat-icon>
            </mat-form-field>
        </div>
        <div class="flex flex-col sm:flex-row">
            <mat-slide-toggle formControlName="active" color="primary">
                Activo
            </mat-slide-toggle>
        </div>
    </mat-dialog-content>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancel()">Cancelar</button>
        <button mat-button color="primary" type="submit" [disabled]="!form.valid">
            {{ mode === 'create' ? 'Crear' : 'Actualizar' }}
        </button>
    </mat-dialog-actions>
</form>

